import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Layout, Menu } from "antd";
import Nav from "../../components/Nav";
import { NeedLoginContext } from "../../components/Nav/need-login";
import TaobaoPanel from './Panel/Index'
import ContactPicture from './containers/ContactPicture'
import { TbLayout } from './components';
import { ShortURLContainer, QrCodeContainer } from './containers';
import "./style.less";

const { Sider, Content } = Layout;
const clsPrefix = "taobao";

const Taobao = () => {
  useEffect(() => {
    //@ts-ignore
    const kaq = window.kaq
    kaq('create', 'taobaoke-center-b')
    kaq('set', 'pageType', 100)
    kaq('send', 'pageview')
  }, [])

return (
    <NeedLoginContext.Provider value={false}>
      <Nav />
      <Layout style={{ maxHeight: "0" }}>
        <Sider className={`${clsPrefix}-sider`} theme='light'>
          <Menu
            theme='light'
            mode='inline'
            defaultSelectedKeys={[window.location.pathname]}
          >
            <Menu.Item key='/v5/taobao'><Link to={{ pathname: "/v5/taobao" }}>淘宝口令一键生成推广页</Link></Menu.Item>
            <Menu.Item key='/v5/taobao/short-url'><Link to={{ pathname: "/v5/taobao/short-url" }}>生成短链接</Link></Menu.Item>
            <Menu.Item key='/v5/taobao/qrcode'><Link to={{ pathname: "/v5/taobao/qrcode" }}>生成二维码商品推广图</Link></Menu.Item>
            <Menu.Item key='/v5/taobao/concat-picture'><Link to={{ pathname: "/v5/taobao/concat-picture" }}>推广拼图</Link></Menu.Item>
            <a className='fake-menu-item' href='/v3/kz-cloud/my-apps' target='_blank'>API接口服务</a>
          </Menu>
        </Sider>
        <Content className={`${clsPrefix}-content`}>
          <TbLayout>
            <Switch>
                <Route path="/v5/taobao" exact component={TaobaoPanel} />
                <Route path="/v5/taobao/short-url" exact component={ShortURLContainer} />
                <Route path="/v5/taobao/concat-picture" exact component={ContactPicture} />
                <Route path="/v5/taobao/qrcode" exact component={QrCodeContainer} />
            </Switch>
          </TbLayout>
        </Content>
      </Layout>
    </NeedLoginContext.Provider>
  )

}

export default Taobao;
